export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-mail-send-line text-sm"></i>
            意见反馈
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed">
            如果您在使用过程中遇到任何问题，或有影片投稿、合作建议，欢迎随时联系我们。
            6080影院团队重视每一位用户的反馈，期待与您共同打造更好的高清在线影院体验。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/60">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 mx-auto mb-3">
                <i className="ri-chat-3-line text-primary-500 text-lg"></i>
              </span>
              <div className="text-sm font-medium text-foreground-200 mb-1">在线反馈</div>
              <div className="text-xs text-foreground-500">service@6080cinema.com</div>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/60">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mx-auto mb-3">
                <i className="ri-film-line text-accent-500 text-lg"></i>
              </span>
              <div className="text-sm font-medium text-foreground-200 mb-1">影片投稿</div>
              <div className="text-xs text-foreground-500">submit@6080cinema.com</div>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/60">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 mx-auto mb-3">
                <i className="ri-briefcase-line text-secondary-500 text-lg"></i>
              </span>
              <div className="text-sm font-medium text-foreground-200 mb-1">商务合作</div>
              <div className="text-xs text-foreground-500">biz@6080cinema.com</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}